module.exports = __webpack_public_path__ + "static/img/program.2676c73.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/code/program.jpg
// module id = uR9r
// module chunks = 11